import { useState } from 'react'
import { emojiSvgUrl } from '../twemoji.js'

// Renders an emoji as a Twemoji SVG (consistent across devices).
// Falls back to native rendering if the SVG fails to load (e.g. custom emoji
// not in Twemoji's set, or offline + uncached).
export function Emoji({ symbol, size = '1.2em', className = '', ...rest }) {
  const [failed, setFailed] = useState(false)
  const url = symbol ? emojiSvgUrl(symbol) : null

  if (!url || failed) {
    return (
      <span className={`emoji emoji-native ${className}`} aria-label={symbol} {...rest}>
        {symbol}
      </span>
    )
  }

  return (
    <img
      src={url}
      alt={symbol}
      draggable={false}
      onError={() => setFailed(true)}
      className={`emoji emoji-twemoji ${className}`}
      style={{ width: size, height: size, ...(rest.style ?? {}) }}
      {...rest}
    />
  )
}
